module.exports = __webpack_public_path__ + "img/home_modal_poster1.ba64c855.png";